import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import dataTestID from '../../../constants/DataTestIndex';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = dynamic(function () {
  return import('../Pagination_v8');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('../Pagination_v8')];
    }
  }
});
export var TableFooter = function TableFooter(_ref) {
  var colorScheme = _ref.colorScheme;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useTableContext = useTableContext(),
      table = _useTableContext.table,
      setPage = _useTableContext.setPage;

  var dataCount = table.getCoreRowModel().rows.length;
  var filteredRows = table.getFilteredRowModel().rows;
  var isFiltered = dataCount !== filteredRows.length;
  var displayDataCount = "".concat(filteredRows.length).concat(isFiltered ? ' / ' + dataCount : '');
  var currentPageDataCount = table.getPaginationRowModel().rows.length;
  return /*#__PURE__*/_jsxs(Flex, {
    bgColor: "white",
    w: "full",
    direction: "row",
    justify: "space-between",
    rounded: "md",
    py: 2,
    e2eid: "CrudTable_TableFooter_Flex",
    children: [/*#__PURE__*/_jsx(Text, {
      color: useColorModeValue('gray.600', 'gray.400'),
      fontSize: "sm",
      "data-test": dataTestID.generalTable.ListItemCount,
      e2eid: "CrudTable_TableFooter_Text",
      children: t('common:table.pageInfo', "\u7576\u524D\u9801 ".concat(currentPageDataCount, " \u7B46\uFF0C\u5171 ").concat(displayDataCount, " \u7B46"), {
        pageSize: currentPageDataCount,
        displayDataCount: displayDataCount
      })
    }), /*#__PURE__*/_jsx(Pagination, {
      colorScheme: colorScheme,
      table: table,
      onPageChange: setPage,
      e2eid: "CrudTable_TableFooter_Pagination"
    })]
  });
};